import type React from 'react'

interface LoadingProps {
  message?: string
  size?: 'small' | 'medium' | 'large'
  fullScreen?: boolean
}

/**
 * A reusable loading component that displays a spinner with an optional message
 */
const LoadingDisplay: React.FC<LoadingProps> = ({ message = 'Loading...', size = 'medium', fullScreen = false }) => {
  // Size mapping
  const sizeMap = {
    small: {
      container: 'p-2',
      spinner: 'h-4 w-4',
      text: 'text-sm',
    },
    medium: {
      container: 'p-4',
      spinner: 'h-8 w-8',
      text: 'text-base',
    },
    large: {
      container: 'p-6',
      spinner: 'h-12 w-12',
      text: 'text-lg',
    },
  }

  const selectedSize = sizeMap[size]

  const containerClasses = `
    flex flex-col items-center justify-center
    ${selectedSize.container}
    ${fullScreen ? 'fixed inset-0 bg-black/50 z-50' : ''}
  `

  return (
    <div className={containerClasses}>
      {/* Spinner */}
      <div
        className={`animate-spin rounded-full border-t-4 border-blue-500 border-opacity-50 border-r-4 ${selectedSize.spinner}`}
      />

      {/* Message */}
      {message && <p className={`mt-4 text-center text-gray-700 ${selectedSize.text}`}>{message}</p>}
    </div>
  )
}

export default LoadingDisplay
